import { DetailedTask, TaskDefaultStatusId } from "@jugl-web/rest-api/tasks";
import { Subject } from "rxjs";

/**
 * Local task action events emitted after successful user-driven mutations.
 * Not related to remote/socket live updates.
 */
export type TaskLocalActionEvent = {
  type: "task-completed";
  taskId: string;
};

const internalEvent$ = new Subject<TaskLocalActionEvent>();
const emit = (event: TaskLocalActionEvent) => internalEvent$.next(event);

/**
 * Emits local task action events based on the applied mutation delta.
 * Should be called after a successful task update.
 */
export const emitTaskLocalActionEvent = (
  taskId: string,
  delta: Partial<DetailedTask>
) => {
  if (delta.status === TaskDefaultStatusId.completed) {
    emit({ type: "task-completed", taskId });
  }
};

/**
 * Read-only stream of local task action events.
 * Used for reacting to local mutations (separate from live updates).
 */
export const taskLocalAction$ = internalEvent$.asObservable();
